import { render } from "./Heading1.vue?vue&type=template&id=fdf3fa88&ts=true"
import script from "./Heading1.vue?vue&type=script&lang=ts"
export * from "./Heading1.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__